import { useEffect, useRef } from 'react';
import { localizeValue } from '../lib/admin-i18n.js';

export default function AdminLocalizedPage({Page,pageProps,language}){
  const root=useRef(null);
  const originalText=useRef(new WeakMap());
  const originalAttrs=useRef(new WeakMap());
  useEffect(()=>{
    if(!root.current)return;
    const node=root.current;
    const protect=(el)=>el?.closest('input,textarea,[data-user-content],[data-localized],.table-product,.customer-cell strong,.employee-cell strong,.supplier-cell strong,.customer-name,.product-name,.employee-name,.address-cell,.ltr-code,.user-content,.data-user-text');
    const apply=()=>{
      const walker=document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
      let textNode;
      while((textNode=walker.nextNode())){
        if(protect(textNode.parentElement))continue;
        const previous=originalText.current.get(textNode);
        // React can reuse a text node for a new total/date/status. Keep that new
        // source; restoring the first value here used to freeze report updates.
        const value=localizeValue(previous,textNode.nodeValue,language);
        const next=value.rendered;
        originalText.current.set(textNode,value);
        if(next!==textNode.nodeValue)textNode.nodeValue=next;
      }
      node.querySelectorAll('[placeholder],[aria-label],[title],[alt]').forEach(el=>{
        if(el.closest('[data-user-content],[data-localized]'))return;
        let originals=originalAttrs.current.get(el);
        if(!originals){originals={};originalAttrs.current.set(el,originals);}
        for(const attr of ['placeholder','aria-label','title','alt']){
          const value=el.getAttribute(attr);
          if(value!==null){
            const nextValue=localizeValue(originals[attr],value,language);
            const next=nextValue.rendered;
            originals[attr]=nextValue;
            if(next!==el.getAttribute(attr))el.setAttribute(attr,next);
          }else delete originals[attr];
        }
      });
    };
    apply();
    const observer=new MutationObserver(apply);
    observer.observe(node,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['placeholder','aria-label','title','alt']});
    return()=>observer.disconnect();
  },[language,Page]);
  return <div ref={root} style={{display:'contents'}}><Page {...pageProps}/></div>;
}
